export default __webpack_public_path__ + "static/media/consultants.7ca721f5.png";